import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-info" }
const _hoisted_2 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_ctx.pagination.total)
    ? (_openBlock(), _createBlock(_component_Pagination, {
        key: 0,
        modelValue: _ctx.currentPage,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
        "total-pages": _ctx.totalPages,
        disabled: _ctx.disabled,
        onChange: _ctx.changePage
      }, _createSlots({ _: 2 }, [
        (_ctx.showPrefix)
          ? {
              name: "prefix",
              fn: _withCtx(() => [
                _createElementVNode("span", null, [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.pagination.offset + 1) + "-" + _toDisplayString(_ctx.pagination.offset + _ctx.pagination.max), 1),
                  _createElementVNode("span", _hoisted_2, "of " + _toDisplayString(_ctx.pagination.total), 1)
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["modelValue", "total-pages", "disabled", "onChange"]))
    : _createCommentVNode("", true)
}